import "./Screens.css";
import AddTraspButton from "../firstTimeUserExperience/commonCom/AddTraspButton";
import AddButtonWithArrow from "../firstTimeUserExperience/commonCom/AddButtonWithArrow";
import { CustomInputTextArea } from "../common/formControls";

const RejectedScreen = ({ setShowModel, interalTenant, setInteralTenant, noteTenant, setNoteTenant, setShowConfirmation }) => {

  const handleChange = (e) => {
    setInteralTenant(e.target.value);
  };

  const handleTenantChange = (e) => {
    setNoteTenant(e.target.value);
  };

  return (
    <>
      <div className="approved-app-form">
        <div className="InnerBody">
          <CustomInputTextArea
            label="Internal Notes"
            name={undefined}
            placeholder="Add note here..."
            isFormControl
            value={interalTenant}
            onChange={handleChange}
            isError={false}
            errorMessages="Add required "
            myClassName="normal_text black w-100 mb-3"
            rows={3}
          />
          <p className="sub_text grey_subtext1 my-2">
            This is internal notes and would not be sent to Tenant
          </p>
          <br />

          <CustomInputTextArea
            label="Tenant Notes"
            name={undefined}
            placeholder="Add note here..."
            isFormControl
            value={noteTenant}
            onChange={handleTenantChange}
            isError={false}
            errorMessages="Add required "
            myClassName="normal_text black w-100 mb-3"
            rows={3}
          />
          <p className="sub_text grey_subtext1 mt-3">This note will be sent to Tenant</p>
        </div>
        <div className="form-actions-footer">
          <AddTraspButton
            type="button"
            onClick={() => {
              setInteralTenant("")
              setNoteTenant("")
              setShowModel(false)
            }}
            bname="Cancel"
            width={"fit-content"}
          />
          <AddButtonWithArrow
            buttonname="Reject"
            onClick={() => {
              setShowModel(false)
              setTimeout(() => {
                setShowConfirmation(true)
              }, 100);
            }}
            minWidth={"fit-content"}
          />
        </div>
      </div>
    </>
  );
};

export default RejectedScreen;
